import type { LocalePreference } from './types'
import { isLocalePreference } from './types'

export const LOCALE_STORAGE_KEY = 'dontpanic:locale-preference'

export function readLocalePreference(): LocalePreference {
  try {
    const raw = localStorage.getItem(LOCALE_STORAGE_KEY)
    if (raw && isLocalePreference(raw)) return raw
  } catch {
    /* ignore */
  }
  return 'auto'
}

export function writeLocalePreference(preference: LocalePreference): void {
  try {
    localStorage.setItem(LOCALE_STORAGE_KEY, preference)
  } catch {
    /* ignore */
  }
}
